const limitText = (txt, lim) => {
  if (txt === null || txt === undefined) return "";
  if (txt.length < lim) return txt;
  return txt.slice(0, lim) + " ...";
};

export { limitText };
